module.exports = __webpack_public_path__ + "images/company/rank_medal/assessment_achievement_count_rank/1_410e7f3f00e51c405b9a421dd4c07b5e.png";